import { Flex } from "@chakra-ui/react"
import { EntityId } from "@jackfruit/common"
import React from "react"
import { CloudImage } from "../../CloudProviderTypes"
import CloudImageBrowser from "../../common/browser/CloudImageBrowser"
import CloudImageBrowserActionsMobile from "../../common/browser/CloudImageBrowserActionsMobile"
import CloudImageBrowserLoader from "../../common/browser/CloudImageBrowserLoader"
import VNZImageSelector from "./VNZImageSelector"

interface Props {
  isLoading: boolean
  allImages: CloudImage[]
  selectedImageIds: EntityId[]
  handleImageSelect: (id: EntityId) => void
  isImportingImages: boolean
  hasSelectedImages: boolean
  handleUploadImages: () => void
}

const VNZImageBrowserMobile: React.FC<Props> = ({
  isLoading,
  allImages,
  selectedImageIds,
  handleImageSelect,
  handleUploadImages,
  hasSelectedImages,
  isImportingImages,
}) => {
  return (
    <Flex flexDirection="column" flex={1} minH={0} overflow="hidden">
      <Flex flex={1} overflowY="scroll" px={4}>
        {isLoading && <CloudImageBrowserLoader />}
        {!isLoading && (
          <CloudImageBrowser
            images={allImages}
            onImageSelect={handleImageSelect}
            selectedImageIds={selectedImageIds}
            imageComponent={VNZImageSelector}
          />
        )}
      </Flex>
      <CloudImageBrowserActionsMobile
        selectedImageIds={selectedImageIds}
        isImportingImages={isImportingImages}
        hasSelectedImages={hasSelectedImages}
        handleUploadImages={handleUploadImages}
      />
    </Flex>
  )
}

export default VNZImageBrowserMobile
